import React from 'react';
import { Route } from 'react-router-dom';
import { ContainerWrapper } from '../../components';
import PostcategoryCreate from './PostcategoryCreate/PostcategoryCreate';
import PostcategoriesList from './PostcategoriesList/PostcategoriesList';
import PostcategoryEdit from './PostcategoryEdit/PostCategoryEdit';
import PostcategoryDelete from './PostcategoryDelete/PostcategoryDelete';

const Postcategories = ({ match }) => {
    return (
        <div className="Postcategories">
            <ContainerWrapper container="post_categories">
                <Route exact path={ match.path } component={PostcategoriesList} />
                <Route exact path={ `${ match.url }/new` } component={PostcategoryCreate} />
                <Route exact path={ `${ match.url }/edit/:post_categoryId` } component={PostcategoryEdit} />
                <Route exact path={ `${ match.url }/Delete/:post_categoryId` } component={PostcategoryDelete} />
            </ContainerWrapper>
        </div>
    );
}

export default Postcategories;
